import { render, staticRenderFns } from "./TrackBullion.vue?vue&type=template&id=0f89d9a8&"
import script from "./TrackBullion.vue?vue&type=script&lang=js&"
export * from "./TrackBullion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports